import { FormGroup } from '../data/form-group';

export class BodyFormGroup {
  name: string | undefined;
  tag: string | undefined;
  description: string | undefined;
  owners: string[] | undefined;
  hide: boolean | undefined;
  options: Record<string, string> | undefined;
  links: Record<string, string> | undefined;

  constructor(formGroup: FormGroup) {
    this.name = formGroup.name;
    this.tag = formGroup.tag;
    this.description = formGroup.description;
    this.owners = formGroup.owners;
    this.hide = formGroup.hide;
    this.options = formGroup.options;
    this.links = formGroup.links;
  }
}
